/* 是否是签约商家 */
const isSignedContractSupply = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "0",
    label: "否",
  },
  {
    value: "1",
    label: "是",
  },
];

/* 商家结算日期 */
const supplySettleDays = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "1",
    label: "日结",
  },
  {
    value: "7",
    label: "周结",
  },
];

const supplySettleBillStatus = [
  {
    value: 0,
    label: "财务待审核",
  },
  {
    value: 1,
    label: "财务待支付",
  },
  {
    value: 2,
    label: "完成",
  },
  {
    value: 3,
    label: "银行处理中",
  },
  {
    value: 4,
    label: "银行转账失败",
  },
  {
    value: 7,
    label: "代采待提交",
  },
  {
    value: 8,
    label: "等待重新提交",
  },
  {
    value: 9,
    label: "已驳回",
  },
  {
    value: 10,
    label: "分账中",
  },
  {
    value: 11,
    label: "分账失败",
  },
];

const freezeBillStatus = [
  {
    value: 0,
    label: "冻结中",
  },
  {
    value: 1,
    label: "代采待审核",
  },
  {
    value: 2,
    label: "已没收",
  },
  {
    value: 3,
    label: "财务待支付",
  },
  {
    value: 4,
    label: "已支付",
  },
  {
    value: 5,
    label: "银行付款中",
  },
  {
    value: 6,
    label: "银行付款失败",
  },
];

export {
  isSignedContractSupply,
  supplySettleDays,
  supplySettleBillStatus,
  freezeBillStatus,
};



// WEBPACK FOOTER //
// ./src/tool/const.js